import { omit } from 'ramda';

import * as actionTypes from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const setIds = (_, { payload }) =>
  payload.map(attentionPoint => ({
    ...omit(['appointment'], attentionPoint),
    appointmentId: attentionPoint.appointment.id,
  }));

const reset = () => [];

export default createReducer(initialState, {
  [actionTypes.FETCH_ATTENTION_POINTS_REQUEST]: reset,
  [actionTypes.FETCH_ATTENTION_POINTS_SUCCESS]: setIds,
  [actionTypes.FETCH_ATTENTION_POINTS_STOP_POLLING]: reset,
});
